import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Role, Unit } from '../../models/unit';
import { Store } from '@ngrx/store';
import * as fromUnits from '../../reducers';
import * as fromUnit from '../../reducers';
import { take } from 'rxjs/operators';
import { UnitService } from '../../services/unit';
import { ModalService } from '../../../lib/services/modal.service';
import { UnitAddUsersComponent } from '../unit-add-users/unit-add-users.component';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UnitAddSubUnitComponent } from '../unit-add-sub-unit/unit-add-sub-unit.component';
import { UnitUserEditComponent } from '../unit-user-edit/unit-user-edit.component';

@Component({
  selector: 'mj-unit-settings',
  templateUrl: 'unit-settings.component.html',
  styleUrls: ['unit-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnitSettingsComponent {
  @Input() unit: Unit;
  @Input() units: Array<any>;
  @Output() update: EventEmitter<{ unit: Unit }> = new EventEmitter<{
    unit: Unit;
  }>();
  @Output() delete: EventEmitter<number> = new EventEmitter<number>();
  users$: Observable<Array<any>>;
  selectedUnit;

  constructor(
    private store: Store<fromUnits.State>,
    private unitService: UnitService,
    private modalService: ModalService,
    private snackbar: MatSnackBar,
    private ref: ChangeDetectorRef,
    private dialog: MatDialog
  ) {
    this.getUsers();
  }

  getUsers() {
    this.users$ = this.store.select(fromUnit.selectUnitUsers);
  }

  onAddUsers() {
    this.modalService.appendComponentToBody(UnitAddUsersComponent, {
      unit: this.unit,
      users$: this.users$,
    });
  }

  onAddSubUnit() {
    this.modalService.appendComponentToBody(UnitAddSubUnitComponent, {
      units: this.units,
      selected: this.unit,
    });
  }

  resendInvitation(user) {
    this.unitService
      .resendInvitation(this.unit.id, user.id)
      .pipe(take(1))
      .subscribe(
        data => {
          this.snackbar.open('Invitation sent', null, {
            duration: 3000,
          });
        },
        () => {
          this.snackbar.open('Something went wrong', null, {
            duration: 3000,
          });
        }
      );
  }

  editUnitUser(unitEmployment) {
    if (this.unit.role === Role.ADMIN || this.unit.role === Role.GOD) {
      this.dialog.open(UnitUserEditComponent, {
        minWidth: '50vw',
        data: { unitEmployment: unitEmployment },
      });
    }
  }

  promptDeleteUnit() {
    this.snackbar
      .open('Are you sure you want to delete this unit?', 'Delete', {
        panelClass: ['snackbar-50', 'snackbar-danger'],
        duration: 8000,
      })
      .afterDismissed()
      .pipe(take(1))
      .subscribe(ev => {
        if (ev.dismissedByAction) {
          this.deleteUnit();
        }
      });
  }

  deleteUnit() {
    const unitId = Number(localStorage.getItem('unit_id'));
    if (unitId !== this.unit.id) {
      this.delete.emit(this.unit.id);
    }
  }

  updateParentHandler($event: Unit) {
    this.update.emit({ unit: $event });
  }
}
